export default __webpack_public_path__ + "assets/images/338a95fc80ca985a4aadfc018d1e93fa.svg";